var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeltaAirlinesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17431_5793)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    transform: "translate(3 3)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9987 36.3792L24.2832 26.8857V6L43.9987 36.3792ZM45.5663 39.9999L24.2832 31.0142V39.9999H45.5663Z",
    fill: "#98002E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56738 36.3791L24.2829 6V26.8857L4.56738 36.3791Z",
    fill: "#E31837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 40.0001H24.2831V31.0144L3 40.0001Z",
    fill: "#E31837"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17431_5793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeltaAirlinesIcon);
export default __webpack_public_path__ + "static/media/delta-airlines-icon.05c7316ad2aab9073fa63c1051eaaca2.svg";
export { ForwardRef as ReactComponent };